import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';

@Component({
  selector: 'app-create-dreams',
  templateUrl: './create-your-dreams.component.html',
  styleUrls: ['./create-your-dreams.component.scss']
})
export class CreateYourDreamsComponent implements OnInit {

  powerItems:any= [
    {image:'../../../../assets/images/create_your_dreams/picture.png', title: 'PICTURE' , description: 'The inner vision of what you want to create.'},
    {image:'../../../../assets/images/create_your_dreams/position.png', title: 'POSITION' , description: 'What makes what you create special and unique.'},
    {image:'../../../../assets/images/create_your_dreams/plan.png', title: 'PLAN' , description: 'Organizing the action needed to bring the picture into reality.'},
    {image:'../../../../assets/images/create_your_dreams/passion.png', title: 'PASSION' , description: 'The fuel that drives the engine of creating.'},
    {image:'../../../../assets/images/create_your_dreams/partners.png', title: 'PARTNERS' , description: 'Who you choose to create with can lift you upward.'},
    {image:'../../../../assets/images/create_your_dreams/persistance.png', title: 'PERSISTENCE' , description: 'The commitment to stay with something until it’s real.'},
    {image:'../../../../assets/images/create_your_dreams/peace.png', title: 'PEACE' , description: 'Finding inner confidence, calm, and well-being right now.'}

  ];

  constructor(private router: Router) { }

  ngOnInit(): void {

  }

  navigateUrl(url:any){
    window.open(url, "_blank");
  }

}
